import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTranslate from '~/hooks/useTranslate';
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom';
import { RootState } from '~/store/types/sharedTypes';
import { compose } from 'redux';
import Logo from '~/components/shared/LogoOld/LogoOld';
import Button, { ButtonType } from '~/components/shared/Button/button';
import {
  BodyContainer,
  MainContainer,
  PageFooter,
} from '~/styles/BaseStyledComponents';
import withValidation, {
  WithValidationProps,
} from '~/components/hoc/withValidation';
import withGtmEvent from '~/components/hoc/withGtmEvent';
import DownArrow from '~/components/shared/DownArrow/DownArrow';
import SpinnerCircular from '~/components/shared/Spinner/SpinnerCircular';
import { theme } from '~/styles/themes';
import { fetchOfferData } from '~/store/actions/loanOfferActions';
import PageHeader from '../../components/shared/PageHeader/PageHeader';
import PageTitle from '../../components/shared/PageTitle/PageTitle';
import IntroductionCard from './components/IntroductionCard';
import LoanConfigurationCard from './components/LoanConfigurationCard';
import LoanTermsCard from './components/LoanTermsCard';
import LoanInfoCard from './components/LoanInfoCard';
import PayoutInfoCard from './components/PayoutInfoCard';
import CompanyOwnersCard from './components/Ownership/CompanyOwnersCard';
import TermsAndConfirmationCard from './components/TermsAndConfirmationCard';
import SignersCard from './components/SignersCard';

const Offer: React.FC<WithValidationProps & RouteComponentProps<any>> = (
  props
) => {
  const { companyId } = props.match.params;

  /* Selectors */

  /** *********************************************************************************************

    ATTENTION: YOU MUST NOT ADD ANY OTHER SELECTOR TO THIS COMPONENT OR ANY OF ITS SUB-COMPONETS

   *********************************************************************************************** */

  const offer = useSelector((state: RootState) =>
    state.loanOffer.overview.find((o) => o.clientId === Number(companyId))
  );
  const { activeCompany, info } = useSelector((state: RootState) => state.user);
  const offerSigners = offer && offer.signers;
  const dispatch = useDispatch();

  /* Other hooks */
  const history = useHistory();
  const t = useTranslate();

  /* Handlers */
  const onBackButtonClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    history.push('/');
  };

  useEffect(() => {
    if (!info.personalNumber) return;
    dispatch(fetchOfferData(activeCompany?.id as number));
  }, [activeCompany]);

  return (
    <MainContainer>
      <PageHeader hideAllMenus>
        <Logo mt={2} mb={4} />
        <PageTitle mb={2}>{t('MyLoanOffer')}</PageTitle>
      </PageHeader>
      {offer ? (
        <BodyContainer>
          <IntroductionCard />
          <DownArrow />
          <LoanConfigurationCard data={offer} />
          <DownArrow />
          <LoanTermsCard data={offer} />
          <DownArrow />
          <LoanInfoCard data={offer} />
          <DownArrow />
          <PayoutInfoCard data={offer} />
          <DownArrow />
          <CompanyOwnersCard data={offer} />
          {offerSigners && offerSigners.length > 0 && <DownArrow />}
          {offerSigners && offerSigners.length > 0 && (
            <SignersCard signers={offerSigners} />
          )}
          <DownArrow />
          <TermsAndConfirmationCard data={offer} hash={null} clientId={null} />
        </BodyContainer>
      ) : (
        <SpinnerCircular color={theme.colors.secondaryGray} />
      )}
      <PageFooter>
        <Button type={ButtonType.Outlined} onClick={onBackButtonClick}>
          {t('BackButton')}
        </Button>
      </PageFooter>
    </MainContainer>
  );
};

export default compose(withGtmEvent, withValidation, withRouter)(Offer);
